module.exports = __webpack_public_path__ + "DejaVuSerif-BoldItalic.42a9a4e0c7d560aa678f.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/DejaVu/DejaVuSerif-BoldItalic.ttf?v=1.1
// module id = ../../../../../external_css/kendo-ui/fonts/DejaVu/DejaVuSerif-BoldItalic.ttf?v=1.1
// module chunks = styles